import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-gradient-to-b from-navy-dark to-navy text-ice pt-20 pb-16 px-4" data-id="element-110">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-111">
        {/* Christ Image Background */}
        <div className="absolute inset-0 bg-[url('https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Cristo_Redentor_-_Rio_de_Janeiro%2C_Brasil.jpg/800px-Cristo_Redentor_-_Rio_de_Janeiro%2C_Brasil.jpg')] bg-cover bg-center bg-no-repeat opacity-10 mix-blend-luminosity" data-id="element-112" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[100px]" data-id="element-113" />
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 mix-blend-overlay" data-id="element-114" />
        {/* Gradient overlay to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-navy-dark via-navy/80 to-transparent" data-id="element-115" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex items-center gap-2 mb-8 bg-black/20 px-4 py-2 rounded-full border border-gold/30 backdrop-blur-sm" data-id="element-117">
          <div className="flex text-gold" data-id="element-118">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-119" />)}
          </div>
          <span className="text-sm font-body text-ice/90" data-id="element-120">
            <strong className="text-gold-light" data-id="element-121">4,291</strong> familias
            protegidas
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight text-ice-light drop-shadow-lg tracking-wide max-w-4xl mx-auto" data-id="element-122">
          Protege a los tuyos con el Escudo de Fe, un manual digital de oración
          que puedes empezar a usar en menos de 5 minutos.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="font-body text-xl md:text-2xl text-gold-light max-w-3xl mx-auto font-bold tracking-wide mb-10 uppercase" data-id="element-123">
          ¿Sientes que el miedo y la inseguridad están ROBANDO la paz de tu
          hogar?
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-12" data-id="element-124">
          <a href="#solucion" className="animate-heartbeat inline-flex items-center justify-center gap-3 px-10 py-5 text-xl font-bold text-navy-dark bg-gradient-to-r from-gold-light via-gold to-gold-dark rounded-full transition-transform duration-300 shadow-[0_0_30px_rgba(197,148,42,0.5)]" data-id="element-125">
            <Shield className="w-6 h-6" data-id="element-126" />
            NECESITO LA ORACIÓN HOY
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut',
        delay: 0.6
      }} className="mb-8 relative flex items-center justify-center" data-id="element-127">
          <div className="absolute inset-0 bg-gold/40 blur-3xl rounded-full animate-pulse-slow" data-id="element-128" />
          <div className="relative z-10" data-id="element-129">
            <Shield className="w-32 h-32 text-gold drop-shadow-[0_0_25px_rgba(197,148,42,0.8)]" strokeWidth={1.5} data-id="element-130" />
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 text-gold drop-shadow-[0_0_15px_rgba(197,148,42,0.8)]" data-id="element-131">
              <path d="M12 4v16M8 9h8" data-id="element-132" />
            </svg>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col items-center w-full max-w-md" data-id="element-133">
          <p className="text-sm md:text-base font-body text-ice/80 italic bg-black/20 px-6 py-2 rounded-full border border-white/10 backdrop-blur-sm" data-id="element-134">
            Efecto de paz al instante
          </p>
        </motion.div>
      </div>

      {/* Bottom decorative divider */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-ice to-transparent" data-id="element-135" />
    </section>;
}